import script from "./ComProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComProfile.vue?vue&type=script&setup=true&lang=ts"

import "./ComProfile.vue?vue&type=style&index=0&id=3d0ab220&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0ab220"]])

export default __exports__